import React from 'react';
import { FastProfitLogo } from './FastProfitLogo';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative w-full min-h-[100svh] flex flex-col items-center justify-center pt-24 pb-32 md:pb-48 overflow-hidden bg-brand-navy" data-id="element-84">
      {/* Ambient city skyline background */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2000&q=80)',
      filter: 'grayscale(25%) brightness(55%)'
    }} aria-hidden="true" data-id="element-85" />

      <div className="absolute inset-0 z-[1] pointer-events-none" style={{
      backgroundColor: 'rgba(11, 31, 58, 0.82)'
    }} aria-hidden="true" data-id="element-86" />

      <div className="absolute inset-0 z-[2] pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(11, 31, 58, 0) 35%, rgba(11, 31, 58, 0.75) 100%)'
    }} aria-hidden="true" data-id="element-87" />

      {/* Subtle gold light beam from top */}
      <div className="absolute inset-x-0 top-0 h-1/2 z-[2] pointer-events-none opacity-30" style={{
      background: 'radial-gradient(ellipse at top, rgba(212, 175, 55, 0.25) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-88" />

      {/* Content */}
      <div className="container relative z-10 mx-auto px-4 flex flex-col items-center text-center mt-8 md:mt-12" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-5xl mx-auto" data-id="element-90">
          {/* Eyebrow — audience callout */}
          <p className="font-display text-brand-gold uppercase tracking-[0.3em] text-xs md:text-sm mb-6 md:mb-8 font-bold" style={{
          textShadow: '0 0 20px rgba(212, 175, 55, 0.45)'
        }} data-id="element-91">
            For New &amp; Experienced Investors
          </p>

          {/* Headline — short and punchy with a glowing gold gradient on the money phrase */}
          <h1 className="font-display font-bold uppercase leading-[1.05] mb-6 md:mb-8 text-white" data-id="element-92">
            <span className="block text-4xl md:text-6xl lg:text-7xl" data-id="element-93">
              Quietly Make
            </span>
            <span className="block text-5xl md:text-7xl lg:text-8xl my-2 md:my-3" style={{
            backgroundImage: 'linear-gradient(180deg, #F4DC8C 0%, #D4AF37 45%, #A87E1F 100%)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
            WebkitTextFillColor: 'transparent',
            filter: 'drop-shadow(0 0 18px rgba(212, 175, 55, 0.55)) drop-shadow(0 2px 4px rgba(0,0,0,0.4))',
            letterSpacing: '0.02em'
          }} data-id="element-94">
              $100K+ Per Deal
            </span>
            <span className="block text-3xl md:text-5xl lg:text-6xl" data-id="element-95">
              In Commercial Real Estate
            </span>
          </h1>

          {/* Sub-headline — restored with mobile breathing room */}
          <p className="font-display text-brand-gold uppercase tracking-[0.15em] text-base md:text-xl lg:text-2xl px-4 md:px-0 mb-10 md:mb-12 leading-snug" data-id="element-96">
            Without a license or massive money
          </p>

          {/* Live on Zoom */}
          <div className="flex justify-center mb-8 md:mb-10" data-id="element-97">
            <div className="inline-flex items-center justify-center bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-8 md:px-10 py-4 md:py-5 shadow-xl" style={{
            boxShadow: '0 0 30px rgba(212, 175, 55, 0.18), 0 8px 24px rgba(0,0,0,0.35)'
          }} data-id="element-98">
              <img src="https://cdn.magicpatterns.com/uploads/exFAxaQLC1uWmCsiim1U3C/69fd5c5d7285562721a05495.png" alt="Live on Zoom" className="h-10 md:h-14 object-contain" loading="eager" decoding="async" data-id="element-99" />
            </div>
          </div>

          {/* Secondary lockup — moved BELOW the badge, smaller, less competing with the headline */}
          <FastProfitLogo size="sm" className="opacity-95" data-id="element-100" />
        </motion.div>
      </div>
    </section>;
}